//SnackBar Store  state and functions
export default {
    state: {
        open: false,
        message: 'info',
        type: '',
    },
    functions: {
        showSnakBar(message, type, timeout = 4000) {
            let state = this.state;
            state.snackbar = {
                message: message,
                type: type,
                open: true,
            };
            this.setState(state);
            setTimeout(() => this.snackbar.hideSnakBar(), timeout);
        },
        hideSnakBar() {
            let state = this.state;
            state.snackbar = {
                message: '',
                type: this.state.snackbar.type,
                open: false,
            };
            this.setState(state);
        }
    }
}


